import React, {useEffect, useRef, useState} from 'react';
import {injectIntl} from '@s7ui-kit/s7ui-kit';
import {connect} from 'react-redux';

import requestUtil from '../../../services/services/requestUtil';
import pushGA from '../../../services/utils/pushGA';
import { ShowMore } from '../../main/ShowMore';

import {
    analyticsMainHelpcenterClickArticle,
    analyticsMainHelpcenterClickMore
} from '../../../services/analytics/analyticsMainpage';

import greenCircle from '../../../assets/images/greenCircle.png';
import { Image } from '@s7/ui';
import './faq-block.scss';

const mapStateToProps = ({App, User}) => ({App, User});
const contentServicePrefix = `${process.env.REACT_APP_PREFIX_CONTENT_SERVICE}/api/v1`;

const FAQBlock = (props) => {
    const {App: {lang, deviceWidth}} = props;
    const {words, getMessage} = props;

    const [questions, setQuestions] = useState([]);
    let questionsLength = 0;

    const faqBlock = useRef();
    const location = window.location.href;

        useEffect(() => {
            const s7PageInit = typeof(window.s7PageInit)!=='undefined' ? window.s7PageInit : {};

            if(s7PageInit.hasOwnProperty('promotedArticles') && s7PageInit.promotedArticles.hasOwnProperty(lang)){
                const responseData = s7PageInit.promotedArticles[lang];

                setQuestions(responseData);
                questionsLength = responseData.length;
            } else {
                requestUtil(`${contentServicePrefix}/content/help-center/promoted-articles?lang=${lang}`)
                    .then(response => {
                        if (!response || response.length === 0) {
                            return;
                        }

                        setQuestions(response);
                        questionsLength = response.length;
                    }).catch((e) => {
                        console.log(e)
                    });
            }

            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            }

        }, []);

    const handleScroll = () => {
        if (faqBlock.current && faqBlock.current.offsetTop && window.pageYOffset >= (faqBlock.current.offsetTop - window.innerHeight) + faqBlock.current.clientHeight / 2) {
            pushHelpcenterGA('Show', undefined, 1, questionsLength);
            window.removeEventListener('scroll', handleScroll);
        }
    };

    const pushHelpcenterGA = (eventAction, flightDetail, eventInteraction, eventValue) => {
        pushGA(
            'Portal Helpcenter Module',
            `${eventAction}`,
            `${location}`,
            {
                eventValue: eventValue,
                flightDetail: flightDetail,
                eventInteraction: eventInteraction,
                eventUX: undefined
            }
        )
    };

    const goToHelpcenter = count => {
        pushHelpcenterGA('GoTo Helpcenter', 'ID:mainpage', 0, count);
        analyticsMainHelpcenterClickMore();
        window.location.href = `https://helpcenter.s7.ru/${lang}/`
    };

    const goToHelpcenterArticle = ({ question, count }) => {
        pushHelpcenterGA('GoTo Helpcenter', `ID:${question.id}`, 0, count);

        analyticsMainHelpcenterClickArticle({
            item_category: undefined,
            item_category2: undefined,
            item_id: question.name
        });
    };

    return (
        questions && Array.isArray(questions) && questions.length > 0 &&
        <section
            className={'faq-block'}
            ref={faqBlock}
        >
            <div className={'faq-block__content'}>
                <div className={'faq-block__content-image content-image'}
                     onClick={() => goToHelpcenter(questions.length)}
                >
                    <div
                        className={'content-image__title'}
                        dangerouslySetInnerHTML={{
                            __html: getMessage(words, 'com.s7.main.page.faq.content.title')
                        }}
                    />
                    <div className={'content-image__icon'}>
                        <Image src={greenCircle} width={240} height={240} />
                    </div>
                </div>
                <div className={'faq-block__content-questions content-questions'}>
                    {
                        questions.map((question) => {
                            return (
                                question.htmlUrl && question.name &&
                                <div
                                    className={'content-questions__item'}
                                    onClick={() => goToHelpcenterArticle({question, count: questions.length})}
                                    key={question.htmlUrl}
                                >
                                    <a
                                        href={question.htmlUrl}
                                    >
                                        {question.name}
                                    </a>
                                </div>
                            )
                        })
                    }
                    <ShowMore
                        text={deviceWidth > 767 ? getMessage(words, 'com.s7.main.page.faq.learn.more') : getMessage(words, 'com.s7.main.page.faq.learn.more.short')}
                        link={`https://helpcenter.s7.ru/${lang}/`}
                        className={'content-questions__learn-more'}
                        onClick={() => goToHelpcenter(questions.length)}
                    />
                </div>
            </div>
        </section>
    )
};

export default injectIntl(connect(mapStateToProps)(React.memo(FAQBlock)));